module.exports = __webpack_public_path__ + "static/images/jf-couponbg02.19e498a.png";